import React from 'react'

import { DOWNLOAD_ICON } from '../../../constants/urls'
import { downloadEvidence } from '../../../utils/download'

interface ShowFullImageProps {
  isOpen?: boolean
  url?: string
  index: number
  setIndex?: (index: number) => void
  total: number
  handleClose?: () => void
  photos: string[]
}

const ShowFullImage: React.FC<ShowFullImageProps> = ({ isOpen, url, index, setIndex, total, handleClose, photos }: ShowFullImageProps) => {
  const handleFullscreenDownload = () => {
    downloadEvidence([photos[index]])
  }

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-10 flex justify-center bg-black bg-opacity-50"
    >
      <div
        className="m-auto relative rounded-3xl bg-white p-4 shadow-lg portrait:mx-4 portrait:border portrait:border-gray-200 max-w-[90vw] max-h-[85vh] overflow-hidden flex flex-col landscape:w-3/5"
      >
        <div className='relative w-full flex-shrink-0'>
          <div className='flex justify-between items-center'>
            <h1 className='text-lg font-bold font-[Onest]'>Archivos adjuntos</h1>

            <div className='flex gap-2 items-center'>
              <button
                type="button"
                className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-gray-600 cursor-pointer hover:bg-gray-100"
                onClick={handleFullscreenDownload}
              >
                <img src={DOWNLOAD_ICON} alt='download' className='w-3' />
              </button>

              <button
                type="button"
                className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-gray-600 cursor-pointer hover:bg-gray-100"
                onClick={handleClose}
              >
                <p className='text-2xl font-medium font-[Onest]'>×</p>
              </button>
            </div>
          </div>
        </div>

        <div className='bg-[#F7F7F7] rounded-lg p-4 mt-4 flex-1 flex flex-col items-center justify-center overflow-hidden min-h-0'>
          <img src={url || ''} alt='evidence' className='max-h-full min-h-0 object-contain rounded-lg' />
          <p className='flex-shrink-0 mt-2'>{photos[index].split('/').pop()}</p>
        </div>

        <div className='flex flex-col gap-2 justify-between items-center mt-2'>
          <p className='text-base font-medium font-[Geist]'>{index + 1} de {total}</p>

          <div className='flex gap-2 justify-center items-center'>
            {
              photos.map((photo, photoIndex) => {
                const selected = photoIndex === index
                return (
                  <div
                    className={`${selected ? 'border-2 border-black rounded-lg' : ''} h-24 cursor-pointer overflow-hidden`}
                    onClick={() => setIndex?.(photoIndex)}
                  >
                    <img
                      src={photo}
                      alt='evidence'
                      className='h-24 w-auto max-w-24 object-cover rounded-lg'
                    />
                  </div>
                )
              })
            }
          </div>
        </div>

      </div>
    </div>
  )
}

export default ShowFullImage
